function hasClass(element, classMatchStr) {
  if (element.className) {
    return !!element.className.match(new RegExp("(\\s|^)".concat(classMatchStr, "(\\s|$)")));
  }
  return false;
}
export default hasClass;